import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { AppProps } from 'next/app';
import { CssBaseline } from '@material-ui/core';
import { storeWrapper } from '@state/store';
import { FontIcons } from '@components/common/head/FontIcons';
import Error from './_error';
import styled from '@emotion/styled';
import { BaseSpinner } from '@components/common/spinner';

interface CustomAppProps extends AppProps {
  pageProps: any;
}

const SPINNER_SIZE: number = 50;

const LoadingSpinner = styled.div(() => ({
  background: 'rgba(19, 19, 19, 0.7)',
  color: '#fff',
  borderRadius: '50%',
  position: 'fixed',
  top: '50%',
  right: '50%',
  padding: 15,
  width: SPINNER_SIZE,
  height: SPINNER_SIZE,
  marginRight: -40,
  marginTop: -40
}));

function App({ Component, pageProps }: CustomAppProps) {
  const { store, props } = storeWrapper.useWrappedStore(pageProps);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    if (store && (store as any).__persistor) {
      (store as any).__persistor.persist();
      setHydrated(true);
    } else {
      setHydrated(true);
    }
  }, [store]);

  if (!hydrated)
    return (
      <LoadingSpinner>
        <BaseSpinner size={SPINNER_SIZE} color={'#fff'} />
      </LoadingSpinner>
    );

  const statusCode: string = props?.err?.statusCode || '';
  const code: string | undefined = props?.err?.code;
  const hasError: boolean = !!statusCode;

  if (hasError) return <Error statusCode={statusCode} code={code} />;

  return (
    <Provider store={store}>
      <CssBaseline />
      <FontIcons />
      <Component {...pageProps} />
    </Provider>
  );
}

export default App;
